<h1 mat-dialog-title>Clear All Assignments</h1>

<div style="margin:24px">
  <div>
    Are you sure you want to clear all of the assignments from your cart?
    @if (!data.containsBundle) {
      <span
        >After clearing, your cart will close.</span
        >
      }
    </div>

    <div mat-dialog-actions>
      <button mat-button (click)="clear()" cdkFocusInitial>
        Yes, clear my cart
      </button>
      <button mat-button (click)="cancel()">Cancel</button>
    </div>
  </div>
